<ng-container *transloco="let t; prefix: this.scope">
  <app-table [columns]="columns" [data]="filteredUsers$ | async" [columnSelector]="false" [searchField]="false">
    <app-table-filter *ngIf="filter$ | async as filter">
      <app-table-filter-item>
        <bl-frontend-text-input
          [leftIcon]="{ name: 'search' }"
          [placeholder]="t('search') + '...'"
          [ngModel]="filter.searchString"
          (ngModelChange)="search($event)"></bl-frontend-text-input>
      </app-table-filter-item>
      <app-table-filter-item>
        <p-checkbox
          [binary]="true"
          [ngModel]="!filter.includeInactive"
          (ngModelChange)="toggleIncludeInactiveUsers()"
          [label]="t('showOnlyActiveUsers')"></p-checkbox>
      </app-table-filter-item>
    </app-table-filter>

    <ng-template tableTemplate="bodyCell" tableBodyCellField="initials" let-user="rowData" let-i="rowIndex">
      <p class="my-1" *ngIf="!hasRightsToChangeInitials(user); else editInitialsTemplate">{{ user.initials }}</p>
      <ng-template #editInitialsTemplate>
        <bl-frontend-text-input
          [ngModel]="user.initials"
          (valueChange)="updateInitials(user, $event)" />
      </ng-template>
    </ng-template>
    <ng-template tableTemplate="bodyCell" tableBodyCellField="roleLabel" let-user="rowData">
      <p class="my-1" *ngIf="!hasRightsToChange(); else editRoleTemplate">{{ user.roleLabel }}</p>
      <ng-template #editRoleTemplate>
        <app-auth-role-selector [user]="user" (roleChange)="updateRole($event)"></app-auth-role-selector>
      </ng-template>
    </ng-template>
    <ng-template tableTemplate="bodyCell" tableBodyCellField="active" let-user="rowData" let-i="rowIndex">
      <div class="w-full text-center">
        <i *ngIf="user.active" class="fa fa-check" style="color: green"> </i>
        <i *ngIf="!user.active" class="fa fa-times" style="color: red"> </i>
      </div>
    </ng-template>
    <ng-template tableTemplate="bodyCell" tableBodyCellField="action" let-user="rowData">
      <bl-frontend-iconbutton
        [name]="user.active ? 'trash-alt' : 'recycle'"
        [pTooltip]="user.active ? t('inactivateUser') : t('activateUser')"
        tooltipPosition="left"
        (click)="toggleUserActiveStatus(user)">
      </bl-frontend-iconbutton>
    </ng-template>
  </app-table>
</ng-container>
